import {
  TextInput,
  required,
  useTranslate,
  SimpleForm,
  RadioButtonGroupInput,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

import { makeStyles, Theme } from "@material-ui/core/styles";
import { Styles } from "@material-ui/styles/withStyles";
import { Typography } from "@material-ui/core";
import { MediaInputField } from "../../../lib/components";
import { RESOURCE_NAME_CATEGORY, CATEGORY_TYPE_CHOICES } from "./constants";
import { MAX_RECORDS_PER_PAGE } from "../../../lib/common";
export const styles: Styles<Theme, any> = {
  number: { display: "block" },
  name: { display: "block" },
  description: { display: "block" },
  formClass: {
    width: "75%",
  },
};
const useStyles = makeStyles(styles);

const CategoryForm = ({ isEdit = false, ...rest }) => {
  const classes = useStyles(rest);
  return (
    <SimpleForm
      variant="filled"
      className={classes.formClass}
      {...rest}
      warnWhenUnsavedChanges
    >
      <SectionTitle label="resources.category.fieldGroups.categoryDetaills" />
      <TextInput
        autoFocus
        source="number"
        label="resources.category.fields.number"
        helperText="resources.category.help.number"
        validate={[required()]}
        fullWidth
      />

      <TextInput
        source="name"
        label="resources.category.fields.name"
        helperText="resources.category.help.name"
        formClassName={classes.name}
        fullWidth
      />

      <RichTextInput
        source="description"
        label="resources.category.fields.description"
        helperText="resources.category.help.description"
        formClassName={classes.description}
      />

      <RadioButtonGroupInput
        source="categoryType"
        label="resources.category.fields.categoryType"
        choices={CATEGORY_TYPE_CHOICES}
        formClassName={classes.description}
        isRequired
        validate={[required()]}
      />
      <ReferenceInput
        source="parentId"
        label="resources.category.fields.parentId"
        fullWidth
        reference={RESOURCE_NAME_CATEGORY}
        perPage={MAX_RECORDS_PER_PAGE}
        sort={{ field: "name", order: "ASC" }}
        filter={isEdit ? { excludeIds: [rest?.id] } : {}}
        key="parentId"
      >
        <AutocompleteInput
          optionText="displayLabel"
          resettable={true}
          allowEmpty={false}
          helperText="resources.category.help.parentId"
        />
      </ReferenceInput>

      <MediaInputField showUploadedFiles={isEdit} />
    </SimpleForm>
  );
};
const SectionTitle = ({ label }: { label: string }) => {
  const translate = useTranslate();

  return (
    <Typography variant="h6" gutterBottom>
      {translate(label)}
    </Typography>
  );
};

export { CategoryForm };
